import React from 'react';
import { MessageSquare, LayoutGrid, FileText, Users, Eye, BarChart2, FileSearch, BookOpen, Star, ChevronsRight } from 'lucide-react';
export const Sidebar = () => {
  return <div className="w-16 bg-[#2d2253] flex flex-col items-center" data-id="element-648">
      <div className="p-4" data-id="element-649">
        <div className="w-8 h-8 bg-gradient-to-br from-blue-400 to-purple-500 rounded-lg flex items-center justify-center" data-id="element-650">
          <div className="w-4 h-4 bg-white rounded-sm" data-id="element-651"></div>
        </div>
      </div>
      <div className="flex flex-col items-center gap-6 mt-4" data-id="element-652">
        <SidebarIcon icon={<LayoutGrid size={20} data-id="element-654" />} active={false} data-id="element-653" />
        <SidebarIcon icon={<MessageSquare size={20} data-id="element-656" />} active={true} data-id="element-655" />
        <SidebarIcon icon={<FileText size={20} data-id="element-658" />} active={false} data-id="element-657" />
        <SidebarIcon icon={<Users size={20} data-id="element-660" />} active={false} data-id="element-659" />
        <SidebarIcon icon={<Eye size={20} data-id="element-662" />} active={false} data-id="element-661" />
        <SidebarIcon icon={<BarChart2 size={20} data-id="element-664" />} active={false} data-id="element-663" />
        <SidebarIcon icon={<FileSearch size={20} data-id="element-666" />} active={false} data-id="element-665" />
        <SidebarIcon icon={<BookOpen size={20} data-id="element-668" />} active={false} data-id="element-667" />
      </div>
      <div className="mt-auto mb-6" data-id="element-669">
        <SidebarIcon icon={<Star size={20} data-id="element-671" />} active={false} data-id="element-670" />
      </div>
      <div className="mb-4" data-id="element-672">
        <ChevronsRight size={20} className="text-gray-400" data-id="element-673" />
      </div>
    </div>;
};
const SidebarIcon = ({
  icon,
  active
}: {
  icon: React.ReactNode;
  active: boolean;
}) => {
  return <div className={`w-10 h-10 flex items-center justify-center rounded-lg ${active ? 'bg-[#3d3264]' : ''}`} data-id="element-674">
      <div className={`text-${active ? 'white' : 'gray-400'}`} data-id="element-675">{icon}</div>
    </div>;
};